import { useQuery, UseQueryOptions } from 'react-query';

import { Guid, LenderInviteView } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDirectConnectLenderInvitesQuery(
	guid: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<LenderInviteView, unknown, LenderInviteView, any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.LenderInvites.Root(guid),
		() => AxiosUtils.getResponseData<LenderInviteView>(api.get(CerebroApiEndpoints.LenderInvites.Root(guid))),
		options
	);
}
